import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

import './style.scss';

const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <Box className="footer">
      <Container maxWidth="xl">
        <p className="small">
          &copy; {t('footer.copyright')} {new Date().getFullYear()} Drug Free Sport International
        </p>
      </Container>
    </Box>
  );
};

export default Footer;
